import { PureLightTheme } from "../../../styles/theme"

export const CardFiltration = {
  maxHeight: '808px',
  height: '100%',
  overflowY: 'auto',
  width: '360px',
  padding: 5,
  '@media (max-width:1200px)': {
    width: '260px',
    paddingX: 3,
  },
  [PureLightTheme.breakpoints.down('md')]: {
    height: 'auto',
    paddingY: 3,
  }
}

export const FiltrationText = {
  mb: "8px",
}

export const FiltrationAutocomplete = {
  marginBottom: "16px" 
}
